export default __webpack_public_path__ + "static/media/SGWI.094dedcf.webm";